// Select.Item does not support empty string values, but we need a selectable "--" option that
// resets a field to empty. This hook provides a sentinel value to use in place of '', and
// converters to map between the sentinel and the actual empty string form value.
const RESET_SENTINEL = '__none__';

const useSelectWithReset = () => ({
  resetValue: RESET_SENTINEL,
  toSelectValue: (v: unknown) => (v != null && v !== '' ? String(v) : RESET_SENTINEL),
  // Tapas v8's Select value can be null, which maps to the same empty form value as the sentinel.
  fromSelectValue: (v: string | null) => (v === RESET_SENTINEL || v == null ? '' : v),
});

export default useSelectWithReset;
